import {
  type WorkerRequirementDomain,
  WorkerRequirementMappingLevel,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";

import { type WorkerRequirement } from "./api/types";

interface IsCredentialRequirementProps {
  requirement: WorkerRequirement;
  domains: WorkerRequirementDomain[];
  qualificationName: string;
  isBaseCredential: boolean;
}

export function isCredentialRequirementForQualification(props: IsCredentialRequirementProps) {
  const { requirement, domains, qualificationName, isBaseCredential } = props;

  if (!isDefined(requirement.requirementMappings)) {
    return false;
  }

  return requirement.requirementMappings.some(
    (mapping) =>
      domains.includes(mapping.attributes.domain) &&
      mapping.attributes.requiredBy.length > 0 &&
      mapping.attributes.qualifications.includes(qualificationName) &&
      (isBaseCredential ? mapping.attributes.level === WorkerRequirementMappingLevel.STATE : true)
  );
}
